<template>
    <footer class="footer" v-if="setup != null" id="footer">
        <div class="container">
            <div class="footer-container">
                <div class="footer-logo">
                    <router-link to="/" @click.native="closeMobileMenu">
                        <img :src="setup.logo_dial" alt="DIAL STROY KZ">
                    </router-link>
                </div>
                <div class="footer-adres">
                    <a :href="setup.gis_link_adres" target="_blank">
                        <p v-html="setup.footer_adres"></p>
                    </a>
                </div>
                <div class="social-items">
                    <a :href="setup.footer_social_links.insta" class="social-item" target="_blank">
                        <svgIcon name="instagram" class="icon-instagram"/>
                    </a>
                    <a :href="setup.footer_social_links.tiktok" class="social-item" target="_blank">
                        <svgIcon name="tiktok" class="icon-tiktok"/>
                    </a>
                    <a :href="setup.footer_social_links.youtube" class="social-item" target="_blank">
                        <svgIcon name="youtube" class="icon-youtube"/>
                    </a>
                    <a :href="setup.footer_social_links.telegram" class="social-item" target="_blank">
                        <svgIcon name="telegram" class="icon-telegram"/>
                    </a>
                </div>
                <div class="copy">
                    <p>{{setup.copyright}}</p>
                </div>
                <div class="made-in">
                    <a href="https://jamagency.kz" target="_blank"><img :src="setup.developer_name" alt=""></a>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue';
    export default {
        name: 'AppFooter',
        data () {
            return {
                lang: window.GlobalLang,
            }
        },
        components: {
            svgIcon,
        },
        computed: mapGetters({
            setup: 'loadPageSetUp',
            openSendwich: 'loadOpenSendwich',
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
            closeMobileMenu() {
                this.$store.commit('Open_Sendwich', false);
                document.getElementsByTagName('body')[0].classList.toggle('overlay-open');
            },
        },
        created() {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/footer/footer.scss';
    @import '@/styles/components/footer/footer-respond.scss';
</style>